import { Serializable } from '../serializable';
import { Type } from '@angular/core';
import { IComponentData } from './IComponentData';

export class ComponentData implements Serializable, IComponentData {
    component: Type<any>;
    inputs: any;
    compRef: any;

    constructor(json: any = null) {
        this.fromJSON(json);
    }

    toJSON(): any {
        return this;
    }

    fromJSON(obj: any): any {
        if (!obj) {
            return;
        }

        Object.assign(this, obj);
    }
}
